import './CasinoCarouselRanking.less';

import React from 'react';
import i18n from '../../common/i18n';
import { NikeCasinoApi } from '../../types/generated/nike-casino-api';
import { useReframe } from 'nike-re-framejs';
import { nickName$ } from '../../common/h&s';
import { ColumnDef } from '@tanstack/react-table';
import { ReactTable } from '../react-table/ReactTable';
import clsx from 'clsx';

function CasinoCarouselRanking({
    leaderboardEntries
}: {
    leaderboardEntries: NikeCasinoApi.CarouselLeaderboardEntryDto[];
}) {
    const { subscribe } = useReframe();
    const myNick = subscribe(nickName$());
    const myLeaderboardPosition = (leaderboardEntries || []).findIndex(value => value.nick === myNick) + 1;
    let page = myLeaderboardPosition ? Math.floor(myLeaderboardPosition / PAGE_SIZE) : undefined;
    return (
        <div className="mt-10">
            <ReactTable
                data={leaderboardEntries.map((v, i) => ({ ...v, index: i + 1 }))}
                columns={columns}
                onThProps={({ header }) => ({
                    className: clsx(
                        'c-orange nui-carousel-tournament-table-header',
                        header.id === 'index' && 'text-left',
                        header.id === 'points' && 'text-right'
                    )
                })}
                onTdProps={({ cell }) => ({
                    className: clsx(
                        'nui-carousel-tournament-row-bg',
                        cell.row.original.nick === myNick ? ' bg-orange-light' : '',
                        cell.column.id === 'index' && 'text-left',
                        cell.column.id === 'points' && 'text-right'
                    )
                })}
                pagination={{ pageSize: PAGE_SIZE, pageIndex: page, hiding: true }}
                style={{ striped: true, orangeHeader: true }}
            />
        </div>
    );
}

const PAGE_SIZE = 50;

const columns: ColumnDef<RankingItem>[] = [
    {
        header: i18n('nui.casino.leader.index'),
        accessorKey: 'index',
        cell: ({ getValue }) => <span data-atid={'spin-id-cell'}>{getValue() || 0}</span>
    },
    {
        header: i18n('nui.casino.leader.nickname'),
        accessorKey: 'nick',
        cell: ({ getValue }) => <span data-atid={'spin-id-cell'}>{getValue() || 0}</span>
    },
    {
        header: i18n('nui.casino.leader.points'),
        accessorKey: 'points',
        cell: ({ getValue }) => (
            <span data-atid={'spin-id-cell'} className="text-right">
                {getValue()}
            </span>
        )
    }
];

type RankingItem = {
    index: number;
    nick: string;
    points: number;
};

export default CasinoCarouselRanking;
